import { defineComponent as p, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const H = { key: 0 }, V = { key: 1 }, f = { key: 2 }, v = { key: 3 }, L = { key: 4 }, h = { key: 5 }, k = {
  name: "ScalarIconRadical"
}, y = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = A(s);
    return (i, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(i.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", H, t[0] || (t[0] = [
        n("path", { d: "M252,80v24a12,12,0,0,1-24,0V92H136.32L91.24,212.21a12,12,0,0,1-22.47,0l-48-128a12,12,0,1,1,22.47-8.43l36.76,98,36.77-98A12,12,0,0,1,128,68H240A12,12,0,0,1,252,80Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", V, t[1] || (t[1] = [
        n("path", {
          d: "M240,80V192a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V80Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M248,80v24a8,8,0,0,1-16,0V88H133.55L87.49,210.81a8,8,0,0,1-15,0l-48-128a8,8,0,1,1,15-5.62L80,185.22l40.51-108A8,8,0,0,1,128,72H240A8,8,0,0,1,248,80Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", f, t[2] || (t[2] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,80a8,8,0,0,1-16,0v-8H125.42l-30,75a8,8,0,0,1-14.86,0l-32-80A8,8,0,1,1,63.43,93L88,154.46,112.57,93A8,8,0,0,1,120,88h80a8,8,0,0,1,8,8Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", v, t[3] || (t[3] = [
        n("path", { d: "M246,80v24a6,6,0,0,1-12,0V86H132.16L85.62,210.11a6,6,0,0,1-11.24,0l-48-128a6,6,0,1,1,11.24-4.22L80,190.91l42.38-113A6,6,0,0,1,128,74H240A6,6,0,0,1,246,80Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", L, t[4] || (t[4] = [
        n("path", { d: "M248,80v24a8,8,0,0,1-16,0V88H133.55L87.49,210.81a8,8,0,0,1-15,0l-48-128a8,8,0,1,1,15-5.62L80,185.22l40.51-108A8,8,0,0,1,128,72H240A8,8,0,0,1,248,80Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", h, t[5] || (t[5] = [
        n("path", { d: "M244,80v24a4,4,0,0,1-8,0V84H130.77l-47,125.4a4,4,0,0,1-7.49,0l-48-128a4,4,0,1,1,7.49-2.81L80,196.61l44.26-118A4,4,0,0,1,128,76H240A4,4,0,0,1,244,80Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
